// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page.company-info-page {
  max-width: 1080px;
  padding-top: 16px;
}
.business-page.company-info-page h1 {
  font-size: clamp(24px, 4vw, 30px);
  margin: 10px 0 5px;
  letter-spacing: -0.03em;
}
.business-page.company-info-page .business-subtitle {
  font-size: 13px;
  margin-bottom: 16px;
  line-height: 1.45;
}
.business-page.company-info-page .section-error {
  margin-bottom: 12px;
}
.business-page.company-info-page .company-info-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}
.business-page.company-info-page .company-info-layout > * {
  min-width: 0;
}
.business-page.company-info-page .company-info-form {
  display: grid;
  gap: 10px;
}
.business-page.company-info-page .company-info-card {
  border: 1px solid #e1e6ef;
  border-radius: 18px;
  background: #fff;
  overflow: hidden;
}
.business-page.company-info-page .company-info-card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
}
.business-page.company-info-page .company-info-card-heading h2 {
  font-size: 16px;
  margin: 0;
  line-height: 1.3;
}
.business-page.company-info-page .company-info-card-heading a {
  font-size: 12px;
  color: #68758b;
  white-space: nowrap;
  text-decoration: none;
}
.business-page.company-info-page .company-info-group {
  border-top: 1px solid #edf0f5;
}
.business-page.company-info-page .company-info-group > summary {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  min-height: 48px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.business-page.company-info-page .company-info-group > summary::-webkit-details-marker {
  display: none;
}
.business-page.company-info-page .company-info-group > summary > span {
  flex: 1 1;
}
.business-page.company-info-page .company-info-group > summary small {
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}
.business-page.company-info-page .company-info-group > summary svg {
  color: #758199;
  flex-shrink: 0;
  transition: transform 0.15s;
}
.business-page.company-info-page .company-info-group[open] > summary svg {
  transform: rotate(180deg);
}
.business-page.company-info-page .company-info-group > summary:focus-visible {
  outline: 3px solid #6177e7;
  outline-offset: -3px;
  border-radius: 10px;
}
.business-page.company-info-page .company-info-group-body {
  padding: 0 16px 16px;
}
.business-page.company-info-page .company-info-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 10px;
}
.business-page.company-info-page .company-info-fields .section-field {
  grid-column: 1/-1;
  min-width: 0;
  gap: 4px;
}
.business-page.company-info-page .company-info-fields .company-info-short {
  grid-column: auto;
}
.business-page.company-info-page .company-info-fields .section-label {
  font-size: 13px;
  font-weight: 500;
}
.business-page.company-info-page .company-info-fields .section-input, .business-page.company-info-page .company-info-fields .section-textarea {
  font-size: 16px;
  min-height: 44px;
  border-radius: 10px;
  padding: 9px 10px;
  background: #fafbfe;
  scroll-margin-top: 100px;
  scroll-margin-bottom: 170px;
}
.business-page.company-info-page .company-info-fields .section-textarea {
  min-height: 66px;
  line-height: 1.4;
}
.business-page.company-info-page .company-info-save {
  padding: 10px 12px;
  border: 1px solid #e1e6ef;
  background: #fff;
  border-radius: 14px;
}
.business-page.company-info-page .company-info-save p {
  margin: 0 0 8px;
  font-size: 12px;
  color: #6f7890;
}
.business-page.company-info-page .company-info-save[data-dirty=true] {
  position: sticky;
  bottom: 12px;
  z-index: 4;
  box-shadow: 0 4px 18px rgba(35, 33, 55, 0.0705882353);
}
.business-page.company-info-page .company-info-save .section-actions {
  gap: 8px;
  flex-wrap: nowrap;
}
.business-page.company-info-page .company-info-save button {
  min-height: 44px;
  white-space: nowrap;
  font-size: 13px;
  padding: 9px 12px;
}
.business-page.company-info-page .company-info-save .business-primary {
  flex: 1 1;
}
.business-page.company-info-page .company-maps {
  display: grid;
  gap: 12px;
  min-width: 0;
}
.business-page.company-info-page .company-map-refresh {
  border: none;
  background: #f2f4f8;
  color: #526079;
  border-radius: 9px;
  padding: 8px 10px;
  min-height: 44px;
  font-size: 12px;
}
.business-page.company-info-page .company-map-note {
  font-size: 12px;
  line-height: 1.5;
  color: #78849a;
  margin: 0 16px 12px;
}
.business-page.company-info-page .company-map-warning {
  font-size: 12px;
  color: #a86616;
  line-height: 1.45;
  margin: 0 16px 12px;
}
.business-page.company-info-page .company-map-cards {
  display: grid;
  gap: 10px;
  padding: 0 12px 12px;
}
.business-page.company-info-page .company-map-cards:empty {
  display: none;
}
.business-page.company-info-page .company-map-card {
  border: 1px solid #e5e9f1;
  background: #fcfdff;
  border-radius: 13px;
  padding: 12px;
  min-width: 0;
}
.business-page.company-info-page .company-map-card > progress {
  width: 100%;
  height: 6px;
  display: block;
  margin: 7px 0 10px;
  border: 0;
  border-radius: 4px;
  overflow: hidden;
  background: #e9edf4;
  accent-color: #3e9471;
}
.business-page.company-info-page .company-map-card > progress::-webkit-progress-bar {
  background: #e9edf4;
  border-radius: 4px;
}
.business-page.company-info-page .company-map-card > progress::-webkit-progress-value {
  background: #3e9471;
  border-radius: 4px;
}
.business-page.company-info-page .company-map-card > progress::-moz-progress-bar {
  background: #3e9471;
  border-radius: 4px;
}
.business-page.company-info-page .company-map-card > .company-map-note, .business-page.company-info-page .company-map-card > .company-map-warning {
  margin: 8px 0 0;
}
.business-page.company-info-page .company-map-card-head {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  gap: 9px;
  align-items: start;
}
.business-page.company-info-page .company-map-card-head h3 {
  font-size: 14px;
  margin: 0 0 4px;
  line-height: 1.3;
}
.business-page.company-info-page .company-map-card-head p {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 10px;
  font-size: 12px;
  color: #7c879b;
  margin: 0;
}
.business-page.company-info-page .company-map-card-head > a {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  color: #63718b;
  font-size: 11px;
  text-decoration: none;
  line-height: 1.5;
}
.business-page.company-info-page .company-platform-icon {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  font-size: 20px;
  font-weight: 650;
}
.business-page.company-info-page .company-platform-icon.yandex {
  color: #e83242;
  background: #fff0f2;
}
.business-page.company-info-page .company-platform-icon.two_gis {
  color: #338a49;
  background: #eaf6eb;
}
.business-page.company-info-page .company-card-rating {
  font-weight: 650;
  color: #766029;
}
.business-page.company-info-page .company-card-completion {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  font-size: 12px;
  color: #6f7890;
}
.business-page.company-info-page .company-card-completion strong {
  color: #232137;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
}
.business-page.company-info-page .company-map-checklist {
  margin-top: 0;
}
.business-page.company-info-page .company-map-checklist summary {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  list-style: none;
  color: #626f86;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
}
.business-page.company-info-page .company-map-checklist summary::-webkit-details-marker {
  display: none;
}
.business-page.company-info-page .company-map-checklist ul {
  list-style: none;
  padding: 0;
  margin: 10px 0;
  display: grid;
  gap: 8px;
}
.business-page.company-info-page .company-map-checklist li {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px;
  font-size: 11px;
  color: #626f86;
}
.business-page.company-info-page .company-map-checklist .company-map-note {
  font-size: 11px;
  margin: 8px 0 0;
}
.business-page.company-info-page .company-field-status {
  color: #76839a;
}
.business-page.company-info-page .company-field-status.available {
  color: #27815b;
}
.business-page.company-info-page .company-field-status.missing, .business-page.company-info-page .company-field-status.mismatch {
  color: #ad611f;
}
.business-page.company-info-page .company-map-review {
  padding: 13px 16px;
  border-top: 1px solid #edf0f5;
  min-width: 0;
}
.business-page.company-info-page .company-map-review p {
  margin: 7px 0;
}
.business-page.company-info-page .company-review-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}
.business-page.company-info-page .company-review-head strong {
  overflow-wrap: anywhere;
}
.business-page.company-info-page .company-review-head > span {
  color: #846b30;
  white-space: nowrap;
}
.business-page.company-info-page .company-review-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  font-size: 11px;
  color: #7b879b;
  line-height: 1.5;
}
.business-page.company-info-page .company-review-pending {
  color: #b36b24;
  background: #fff4e8;
  padding: 0 6px;
  border-radius: 5px;
}
.business-page.company-info-page .company-review-text, .business-page.company-info-page .company-review-full p, .business-page.company-info-page .company-review-response p {
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.business-page.company-info-page .company-review-full summary {
  list-style: none;
  cursor: pointer;
}
.business-page.company-info-page .company-review-full summary::-webkit-details-marker {
  display: none;
}
.business-page.company-info-page .company-review-full summary span {
  display: block;
  font-size: 13px;
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.business-page.company-info-page .company-review-full summary b {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  color: #68758b;
  padding: 6px 0;
}
.business-page.company-info-page .company-review-full[open] summary span {
  display: none;
}
.business-page.company-info-page .company-review-response {
  padding: 8px 10px;
  background: #f5f7fb;
  border-radius: 9px;
  margin-top: 8px;
}
.business-page.company-info-page .company-review-response summary {
  font-size: 12px;
  color: #68758b;
  cursor: pointer;
}
.business-page.company-info-page .company-more-reviews > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  min-height: 44px;
  box-sizing: border-box;
  cursor: pointer;
  list-style: none;
  border-top: 1px solid #edf0f5;
  font-size: 13px;
  color: #68758b;
}
.business-page.company-info-page .company-more-reviews > summary::-webkit-details-marker {
  display: none;
}
@media (max-width: 767px) {
  .business-page.company-info-page {
    padding: 12px 12px 28px;
  }
  .business-page.company-info-page .business-subtitle {
    margin-bottom: 12px;
  }
  .business-page.company-info-page .company-info-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .business-page.company-info-page .company-info-card-heading {
    padding: 12px 14px;
  }
  .business-page.company-info-page .company-info-card-heading h2 {
    font-size: 15px;
  }
  .business-page.company-info-page .company-info-group > summary {
    padding: 11px 14px;
  }
  .business-page.company-info-page .company-info-group-body {
    padding: 0 14px 14px;
  }
  .business-page.company-info-page .company-info-save[data-dirty=true] {
    bottom: calc(66px + env(safe-area-inset-bottom, 0px));
  }
  .business-page.company-info-page .company-map-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding: 0 10px 10px;
  }
  .business-page.company-info-page .company-map-card {
    padding: 10px;
  }
  .business-page.company-info-page .company-map-card-head {
    grid-template-columns: 25px minmax(0, 1fr);
    gap: 6px;
  }
  .business-page.company-info-page .company-map-card-head > a {
    grid-column: 1/-1;
    min-height: 44px;
    display: flex;
    align-items: center;
  }
  .business-page.company-info-page .company-map-card-head h3 {
    font-size: 13px;
  }
  .business-page.company-info-page .company-map-card-head p {
    font-size: 11px;
  }
  .business-page.company-info-page .company-platform-icon {
    width: 25px;
    height: 25px;
    font-size: 18px;
    border-radius: 8px;
  }
  .business-page.company-info-page .company-card-completion {
    margin-top: 8px;
    font-size: 11px;
  }
  .business-page.company-info-page .company-card-completion strong {
    font-size: 15px;
  }
  .business-page.company-info-page .company-map-checklist summary {
    min-height: 44px;
    align-items: center;
    font-size: 11px;
  }
}
.business-page.company-info-page .company-info-card-heading > a {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
}
.business-page.company-info-page .company-map-checklist summary svg, .business-page.company-info-page .company-more-reviews summary svg {
  flex-shrink: 0;
  transition: transform 0.15s;
}
.business-page.company-info-page .company-map-checklist[open] > summary svg, .business-page.company-info-page .company-more-reviews[open] > summary svg {
  transform: rotate(180deg);
}
@media (prefers-reduced-motion: reduce) {
  .business-page.company-info-page .company-info-group > summary svg, .business-page.company-info-page .company-map-checklist > summary svg, .business-page.company-info-page .company-more-reviews > summary svg {
    transition: none;
  }
}

.business-page.company-info-page .company-verification {
  display: grid;
  gap: 4px;
  margin: 10px 0 0;
  font-size: 12px;
  color: #68758b;
}
.business-page.company-info-page .company-verification strong {
  font-weight: 600;
}
.business-page.company-info-page .company-verification span {
  font-size: 11px;
}
.business-page.company-info-page .company-verification.yes strong {
  color: #1875c9;
}
.business-page.company-info-page .company-access-warning {
  background: #fff5e8;
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
}
.business-page.company-info-page .company-unmanaged-card {
  margin: 0 12px 12px;
}
.business-page.company-info-page .company-unmanaged-card h3 {
  margin: 0 0 5px;
  font-size: 14px;
}
.business-page.company-info-page .company-unmanaged-card > a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 12px;
  color: #526079;
}
.business-page.company-info-page .company-review-filters {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.business-page.company-info-page .company-review-filters {
  padding: 0 16px 16px;
}
.business-page.company-info-page .company-review-filters .company-review-search {
  grid-column: 1/-1;
}
.business-page.company-info-page .company-review-filters label {
  display: grid;
  gap: 5px;
  min-width: 0;
  font-size: 12px;
  color: #526079;
}
.business-page.company-info-page .company-review-filters input, .business-page.company-info-page .company-review-filters select {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: 44px;
  padding: 8px;
  border: 1px solid #dce2ed;
  border-radius: 9px;
  background: #fafbfe;
  font-size: 16px;
  color: #232137;
}
.business-page.company-info-page .company-review-filters button {
  min-height: 44px;
  cursor: pointer;
}
.business-page.company-info-page .company-review-filters button:disabled {
  cursor: default;
  opacity: 0.6;
}
.business-page.company-info-page .company-review-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px;
  font-size: 13px;
}
.business-page.company-info-page .company-review-pagination button {
  border: 1px solid #dce2ed;
  background: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  min-height: 44px;
}
.business-page.company-info-page .company-review-response > strong {
  font-size: 12px;
  color: #478065;
}
@media (max-width: 390px) {
  .business-page.company-info-page .company-map-cards {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CompanyInfoPage/companyInfo.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,iBAAA;AACF;AAAE;EAAK,iCAAA;EAAmC,kBAAA;EAAoB,uBAAA;AAK9D;AAJE;EAAqB,eAAA;EAAiB,mBAAA;EAAqB,iBAAA;AAS7D;AARE;EAAiB,mBAAA;AAWnB;AAVE;EAAuB,aAAA;EAAe,oDAAA;EAAsD,SAAA;EAAW,kBAAA;AAgBzG;AAhB6H;EAAM,YAAA;AAmBnI;AAlBE;EAAqB,aAAA;EAAe,SAAA;AAsBtC;AArBE;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,gBAAA;AA2BzF;AA1BE;EAA6B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,kBAAA;AAiC9G;AAjCkI;EAAK,eAAA;EAAiB,SAAA;EAAW,gBAAA;AAsCnK;AAtCuL;EAAI,eAAA;EAAiB,cAAA;EAAgB,mBAAA;EAAqB,qBAAA;AA4CjP;AA3CE;EAAsB,6BAAA;AA8CxB;AA7CI;EAAY,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,gBAAA;EAAkB,sBAAA;EAAwB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AAyDlL;AAxDM;EAA4B,aAAA;AA2DlC;AA3DmD;EAAS,SAAA;AA8D5D;AA9DuE;EAAQ,eAAA;EAAiB,gBAAA;EAAkB,kCAAA;AAmElH;AAnEwJ;EAAM,cAAA;EAAgB,cAAA;EAAgB,2BAAA;AAwE9L;AAtEI;EAAwB,yBAAA;AAyE5B;AAxEI;EAA0B,0BAAA;EAA4B,oBAAA;EAAsB,mBAAA;AA6EhF;AA3EE;EAA2B,oBAAA;AA8E7B;AA7EE;EAAuB,aAAA;EAAe,gDAAA;EAAkD,cAAA;AAkF1F;AAjFI;EAAiB,iBAAA;EAAqB,YAAA;EAAc,QAAA;AAsFxD;AArFI;EAAsB,iBAAA;AAwF1B;AAvFI;EAAiB,eAAA;EAAiB,gBAAA;AA2FtC;AA1FI;EAAoC,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,iBAAA;EAAmB,mBAAA;EAAqB,wBAAA;EAA0B,2BAAA;AAmGlK;AAlGI;EAAoB,gBAAA;EAAkB,gBAAA;AAsG1C;AApGE;EAAqB,kBAAA;EAAoB,yBAAA;EAA2B,gBAAA;EAAkB,mBAAA;AA0GxF;AAzGI;EAAI,eAAA;EAAiB,eAAA;EAAiB,cAAA;AA8G1C;AA7GI;EAAqB,gBAAA;EAAkB,YAAA;EAAc,UAAA;EAAY,qDAAA;AAmHrE;AAlHI;EAAmB,QAAA;EAAU,iBAAA;AAsHjC;AArHI;EAAS,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAAiB,iBAAA;AA2HrE;AA1HI;EAAoB,SAAA;AA6HxB;AA3HE;EAAgB,aAAA;EAAe,SAAA;EAAW,YAAA;AAgI5C;AA/HE;EAAuB,YAAA;EAAc,mBAAA;EAAqB,cAAA;EAAgB,kBAAA;EAAoB,iBAAA;EAAmB,gBAAA;EAAkB,eAAA;AAwIrI;AAvIE;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,mBAAA;AA6IzE;AA5IE;EAAuB,eAAA;EAAiB,cAAA;EAAgB,iBAAA;EAAmB,mBAAA;AAkJ7E;AAjJE;EAAqB,aAAA;EAAe,SAAA;EAAW,oBAAA;AAsJjD;AAtJuE;EAAU,aAAA;AAyJjF;AAxJE;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,YAAA;AA+J1G;AA9JI;EAAa,WAAA;EAAa,WAAA;EAAa,cAAA;EAAgB,kBAAA;EAAoB,SAAA;EAAW,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;EAAqB,qBAAA;AAyKrJ;AAxKM;EAA0B,mBAAA;EAAqB,kBAAA;AA4KrD;AA5K2E;EAA4B,mBAAA;EAAqB,kBAAA;AAgL5H;AAhLkJ;EAAuB,mBAAA;EAAqB,kBAAA;AAoL9L;AAlLI;EAA8C,eAAA;AAqLlD;AAnLE;EAAyB,aAAA;EAAe,+CAAA;EAAiD,QAAA;EAAU,kBAAA;AAyLrG;AAxLI;EAAK,eAAA;EAAiB,eAAA;EAAiB,gBAAA;AA6L3C;AA5LI;EAAI,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,eAAA;EAAiB,cAAA;EAAgB,SAAA;AAoMxF;AAnMI;EAAM,gBAAA;EAAkB,oBAAA;EAAsB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;EAAiB,qBAAA;EAAuB,gBAAA;AA4M/H;AA1ME;EAAyB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;AAmN/H;AAlNI;EAAW,cAAA;EAAgB,mBAAA;AAsN/B;AAtNsD;EAAY,cAAA;EAAgB,mBAAA;AA0NlF;AAxNE;EAAuB,gBAAA;EAAkB,cAAA;AA4N3C;AA3NE;EAA2B,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,QAAA;EAAU,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAoO9I;AApO8J;EAAS,cAAA;EAAgB,eAAA;EAAiB,kCAAA;AAyOxM;AAxOE;EAAyB,aAAA;AA2O3B;AA3O0C;EAAU,aAAA;EAAe,8BAAA;EAAgC,QAAA;EAAU,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AAqPlL;AArPmM;EAA4B,aAAA;AAwP/N;AAvPI;EAAK,gBAAA;EAAkB,UAAA;EAAY,cAAA;EAAgB,aAAA;EAAe,QAAA;AA8PtE;AA9PkF;EAAK,aAAA;EAAe,eAAA;EAAiB,8BAAA;EAAgC,QAAA;EAAU,eAAA;EAAiB,cAAA;AAsQlL;AArQI;EAAoB,eAAA;EAAiB,eAAA;AAyQzC;AAvQE;EAAwB,cAAA;AA0Q1B;AA1Q0C;EAAc,cAAA;AA6QxD;AA7Q0E;EAAwB,cAAA;AAgRlG;AA/QE;EAAsB,kBAAA;EAAoB,6BAAA;EAA+B,YAAA;AAoR3E;AApRyF;EAAI,aAAA;AAuR7F;AAtRE;EAAuB,aAAA;EAAe,qBAAA;EAAuB,8BAAA;EAAgC,SAAA;EAAW,eAAA;AA6R1G;AA7R2H;EAAS,uBAAA;AAgSpI;AAhS+J;EAAS,cAAA;EAAgB,mBAAA;AAoSxL;AAnSE;EAAuB,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA2SpG;AA1SE;EAA0B,cAAA;EAAgB,mBAAA;EAAqB,cAAA;EAAgB,kBAAA;AAgTjF;AA/SE;EAA2E,eAAA;EAAiB,iBAAA;EAAmB,qBAAA;EAAuB,uBAAA;AAqTxI;AApTE;EAA+B,gBAAA;EAAkB,eAAA;AAwTnD;AAxToE;EAA4B,aAAA;AA2ThG;AA3TiH;EAAO,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,qBAAA;EAAuB,uBAAA;AAkUnM;AAlU8N;EAAI,qBAAA;EAAuB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,cAAA;AAyU5S;AAxUE;EAA0C,aAAA;AA2U5C;AA1UE;EAA2B,iBAAA;EAAmB,mBAAA;EAAqB,kBAAA;EAAoB,eAAA;AAgVzF;AAhV0G;EAAU,eAAA;EAAiB,cAAA;EAAgB,eAAA;AAqVrJ;AApV0B;EAAY,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,kBAAA;EAAoB,gBAAA;EAAkB,sBAAA;EAAwB,eAAA;EAAiB,gBAAA;EAAkB,6BAAA;EAA+B,eAAA;EAAiB,cAAA;AAiW3P;AAjW2Q;EAA4B,aAAA;AAoWvS;AAnWE;EACE;IAAI,uBAAA;EAsWN;EAtW+B;IAAqB,mBAAA;EAyWpD;EAxWE;IAAuB,qCAAA;IAAuC,SAAA;EA4WhE;EA3WE;IAA6B,kBAAA;EA8W/B;EA9WmD;IAAK,eAAA;EAiXxD;EAhXE;IAAgC,kBAAA;EAmXlC;EAlXE;IAA2B,oBAAA;EAqX7B;EApXE;IAAsC,qDAAA;EAuXxC;EAtXE;IAAqB,gDAAA;IAAkD,QAAA;IAAU,oBAAA;EA2XnF;EA1XE;IAAoB,aAAA;EA6XtB;EA5XE;IAAyB,0CAAA;IAA4C,QAAA;EAgYvE;EA/XI;IAAM,iBAAA;IAAqB,gBAAA;IAAkB,aAAA;IAAe,mBAAA;EAqYhE;EApYI;IAAK,eAAA;EAuYT;EAvY4B;IAAI,eAAA;EA0YhC;EAxYE;IAAyB,WAAA;IAAa,YAAA;IAAc,eAAA;IAAiB,kBAAA;EA8YvE;EA7YE;IAA2B,eAAA;IAAiB,eAAA;EAiZ9C;EAjZ+D;IAAS,eAAA;EAoZxE;EAnZE;IAAiC,gBAAA;IAAkB,mBAAA;IAAqB,eAAA;EAwZ1E;AACF;AAvZE;EAAiC,gBAAA;EAAkB,oBAAA;EAAsB,mBAAA;AA4Z3E;AA1ZI;EAAc,cAAA;EAAgB,2BAAA;AA8ZlC;AA7ZI;EAAwB,yBAAA;AAga5B;AA9ZE;EAA+G;IAAgB,gBAAA;EAka/H;AACF;;AA9ZE;EAAwB,aAAA;EAAe,QAAA;EAAU,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAsatF;AAtasG;EAAS,gBAAA;AAya/G;AAzamI;EAAO,eAAA;AA4a1I;AA5aqK;EAAS,cAAA;AA+a9K;AA9aE;EAA0B,mBAAA;EAAqB,aAAA;EAAe,kBAAA;EAAoB,gBAAA;AAobpF;AAnbE;EAA0B,mBAAA;AAsb5B;AAtbiD;EAAK,eAAA;EAAiB,eAAA;AA0bvE;AA1b0F;EAAM,oBAAA;EAAsB,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAic9K;AAhcE;EAA0B,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAqc7F;AApcE;EAA0B,oBAAA;AAuc5B;AAvckD;EAAyB,iBAAA;AA0c3E;AAzc4B;EAAQ,aAAA;EAAe,QAAA;EAAU,YAAA;EAAc,eAAA;EAAiB,cAAA;AAgd5F;AAhd8G;EAAgB,WAAA;EAAa,YAAA;EAAc,sBAAA;EAAwB,gBAAA;EAAkB,YAAA;EAAc,yBAAA;EAA2B,kBAAA;EAAoB,mBAAA;EAAqB,eAAA;EAAiB,cAAA;AA4dtS;AA5dwT;EAAS,gBAAA;EAAkB,eAAA;AAgenV;AAhesW;EAAkB,eAAA;EAAiB,YAAA;AAoezY;AAneE;EAA6B,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;EAAW,aAAA;EAAe,eAAA;AA2etH;AA3euI;EAAS,yBAAA;EAA2B,gBAAA;EAAkB,kBAAA;EAAoB,iBAAA;EAAmB,gBAAA;AAkfpO;AAjfE;EAAoC,eAAA;EAAiB,cAAA;AAqfvD;AApfE;EAA2B;IAAqB,qCAAA;EAwfhD;AACF","sourcesContent":[".business-page.company-info-page {\n  max-width: 1080px;\n  padding-top: 16px;\n  h1 { font-size: clamp(24px, 4vw, 30px); margin: 10px 0 5px; letter-spacing: -.03em; }\n  .business-subtitle { font-size: 13px; margin-bottom: 16px; line-height: 1.45; }\n  .section-error { margin-bottom: 12px; }\n  .company-info-layout { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 16px; align-items: start; > * { min-width: 0; } }\n  .company-info-form { display: grid; gap: 10px; }\n  .company-info-card { border: 1px solid #e1e6ef; border-radius: 18px; background: #fff; overflow: hidden; }\n  .company-info-card-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 14px 16px; h2 { font-size: 16px; margin: 0; line-height: 1.3; } a { font-size: 12px; color: #68758b; white-space: nowrap; text-decoration: none; } }\n  .company-info-group { border-top: 1px solid #edf0f5;\n    > summary { list-style: none; display: flex; align-items: center; gap: 10px; padding: 12px 16px; min-height: 48px; box-sizing: border-box; font-size: 14px; font-weight: 600; cursor: pointer;\n      &::-webkit-details-marker { display: none; } > span { flex: 1; } small { font-size: 12px; font-weight: 500; font-variant-numeric: tabular-nums; } svg { color: #758199; flex-shrink: 0; transition: transform .15s; }\n    }\n    &[open] > summary svg { transform: rotate(180deg); }\n    > summary:focus-visible { outline: 3px solid #6177e7; outline-offset: -3px; border-radius: 10px; }\n  }\n  .company-info-group-body { padding: 0 16px 16px; }\n  .company-info-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px 10px;\n    .section-field { grid-column: 1 / -1; min-width: 0; gap: 4px; }\n    .company-info-short { grid-column: auto; }\n    .section-label { font-size: 13px; font-weight: 500; }\n    .section-input, .section-textarea { font-size: 16px; min-height: 44px; border-radius: 10px; padding: 9px 10px; background: #fafbfe; scroll-margin-top: 100px; scroll-margin-bottom: 170px; }\n    .section-textarea { min-height: 66px; line-height: 1.4; }\n  }\n  .company-info-save { padding: 10px 12px; border: 1px solid #e1e6ef; background: #fff; border-radius: 14px;\n    p { margin: 0 0 8px; font-size: 12px; color: #6f7890; }\n    &[data-dirty=true] { position: sticky; bottom: 12px; z-index: 4; box-shadow: 0 4px 18px #23213712; }\n    .section-actions { gap: 8px; flex-wrap: nowrap; }\n    button { min-height: 44px; white-space: nowrap; font-size: 13px; padding: 9px 12px; }\n    .business-primary { flex: 1; }\n  }\n  .company-maps { display: grid; gap: 12px; min-width: 0; }\n  .company-map-refresh { border: none; background: #f2f4f8; color: #526079; border-radius: 9px; padding: 8px 10px; min-height: 44px; font-size: 12px; }\n  .company-map-note { font-size: 12px; line-height: 1.5; color: #78849a; margin: 0 16px 12px; }\n  .company-map-warning { font-size: 12px; color: #a86616; line-height: 1.45; margin: 0 16px 12px; }\n  .company-map-cards { display: grid; gap: 10px; padding: 0 12px 12px; &:empty { display: none; } }\n  .company-map-card { border: 1px solid #e5e9f1; background: #fcfdff; border-radius: 13px; padding: 12px; min-width: 0;\n    > progress { width: 100%; height: 6px; display: block; margin: 7px 0 10px; border: 0; border-radius: 4px; overflow: hidden; background: #e9edf4; accent-color: #3e9471;\n      &::-webkit-progress-bar { background: #e9edf4; border-radius: 4px; } &::-webkit-progress-value { background: #3e9471; border-radius: 4px; } &::-moz-progress-bar { background: #3e9471; border-radius: 4px; }\n    }\n    > .company-map-note, > .company-map-warning { margin: 8px 0 0; }\n  }\n  .company-map-card-head { display: grid; grid-template-columns: 30px minmax(0, 1fr) auto; gap: 9px; align-items: start;\n    h3 { font-size: 14px; margin: 0 0 4px; line-height: 1.3; }\n    p { display: flex; flex-wrap: wrap; gap: 5px 10px; font-size: 12px; color: #7c879b; margin: 0; }\n    > a { min-height: 44px; display: inline-flex; align-items: center; color: #63718b; font-size: 11px; text-decoration: none; line-height: 1.5; }\n  }\n  .company-platform-icon { display: grid; place-items: center; width: 30px; height: 30px; border-radius: 9px; font-size: 20px; font-weight: 650;\n    &.yandex { color: #e83242; background: #fff0f2; } &.two_gis { color: #338a49; background: #eaf6eb; }\n  }\n  .company-card-rating { font-weight: 650; color: #766029; }\n  .company-card-completion { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-top: 14px; font-size: 12px; color: #6f7890; strong { color: #232137; font-size: 16px; font-variant-numeric: tabular-nums; } }\n  .company-map-checklist { margin-top: 0; summary { display: flex; justify-content: space-between; gap: 6px; list-style: none; color: #626f86; font-size: 12px; line-height: 1.4; cursor: pointer; &::-webkit-details-marker { display: none; } }\n    ul { list-style: none; padding: 0; margin: 10px 0; display: grid; gap: 8px; } li { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 4px; font-size: 11px; color: #626f86; }\n    .company-map-note { font-size: 11px; margin: 8px 0 0; }\n  }\n  .company-field-status { color: #76839a; &.available { color: #27815b; } &.missing, &.mismatch { color: #ad611f; } }\n  .company-map-review { padding: 13px 16px; border-top: 1px solid #edf0f5; min-width: 0; p { margin: 7px 0; } }\n  .company-review-head { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; font-size: 13px; strong { overflow-wrap: anywhere; } > span { color: #846b30; white-space: nowrap; } }\n  .company-review-meta { display: flex; flex-wrap: wrap; gap: 5px; font-size: 11px; color: #7b879b; line-height: 1.5; }\n  .company-review-pending { color: #b36b24; background: #fff4e8; padding: 0 6px; border-radius: 5px; }\n  .company-review-text, .company-review-full p, .company-review-response p { font-size: 13px; line-height: 1.55; white-space: pre-wrap; overflow-wrap: anywhere; }\n  .company-review-full summary { list-style: none; cursor: pointer; &::-webkit-details-marker { display: none; } span { display: block; font-size: 13px; line-height: 1.55; white-space: pre-wrap; overflow-wrap: anywhere; } b { display: inline-block; font-size: 12px; font-weight: 500; color: #68758b; padding: 6px 0; } }\n  .company-review-full[open] summary span { display: none; }\n  .company-review-response { padding: 8px 10px; background: #f5f7fb; border-radius: 9px; margin-top: 8px; summary { font-size: 12px; color: #68758b; cursor: pointer; } }\n  .company-more-reviews { > summary { display: flex; align-items: center; justify-content: space-between; padding: 13px 16px; min-height: 44px; box-sizing: border-box; cursor: pointer; list-style: none; border-top: 1px solid #edf0f5; font-size: 13px; color: #68758b; &::-webkit-details-marker { display: none; } } }\n  @media (max-width: 767px) {\n    & { padding: 12px 12px 28px; .business-subtitle { margin-bottom: 12px; } }\n    .company-info-layout { grid-template-columns: minmax(0, 1fr); gap: 12px; }\n    .company-info-card-heading { padding: 12px 14px; h2 { font-size: 15px; } }\n    .company-info-group > summary { padding: 11px 14px; }\n    .company-info-group-body { padding: 0 14px 14px; }\n    .company-info-save[data-dirty=true] { bottom: calc(66px + env(safe-area-inset-bottom, 0px)); }\n    .company-map-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; padding: 0 10px 10px; }\n    .company-map-card { padding: 10px; }\n    .company-map-card-head { grid-template-columns: 25px minmax(0, 1fr); gap: 6px;\n      > a { grid-column: 1 / -1; min-height: 44px; display: flex; align-items: center; }\n      h3 { font-size: 13px; } p { font-size: 11px; }\n    }\n    .company-platform-icon { width: 25px; height: 25px; font-size: 18px; border-radius: 8px; }\n    .company-card-completion { margin-top: 8px; font-size: 11px; strong { font-size: 15px; } }\n    .company-map-checklist summary { min-height: 44px; align-items: center; font-size: 11px; }\n  }\n  .company-info-card-heading > a { min-height: 44px; display: inline-flex; align-items: center; }\n  .company-map-checklist, .company-more-reviews {\n    summary svg { flex-shrink: 0; transition: transform .15s; }\n    &[open] > summary svg { transform: rotate(180deg); }\n  }\n  @media (prefers-reduced-motion: reduce) { .company-info-group, .company-map-checklist, .company-more-reviews { > summary svg { transition: none; } } }\n\n}\n\n.business-page.company-info-page {\n  .company-verification { display: grid; gap: 4px; margin: 10px 0 0; font-size: 12px; color: #68758b; strong { font-weight: 600; } span { font-size: 11px; } &.yes { strong { color: #1875c9; } } }\n  .company-access-warning { background: #fff5e8; padding: 10px; border-radius: 8px; margin-top: 10px; }\n  .company-unmanaged-card { margin: 0 12px 12px; h3 { margin: 0 0 5px; font-size: 14px; } > a { display: inline-flex; align-items: center; min-height: 44px; font-size: 12px; color: #526079; } }\n  .company-review-filters { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\n  .company-review-filters { padding: 0 16px 16px; .company-review-search { grid-column: 1 / -1; } }\n  .company-review-filters { label { display: grid; gap: 5px; min-width: 0; font-size: 12px; color: #526079; } input, select { width: 100%; min-width: 0; box-sizing: border-box; min-height: 44px; padding: 8px; border: 1px solid #dce2ed; border-radius: 9px; background: #fafbfe; font-size: 16px; color: #232137; } button { min-height: 44px; cursor: pointer; } button:disabled { cursor: default; opacity: .6; } }\n  .company-review-pagination { display: flex; align-items: center; justify-content: center; gap: 16px; padding: 12px; font-size: 13px; button { border: 1px solid #dce2ed; background: #fff; border-radius: 8px; padding: 8px 12px; min-height: 44px; } }\n  .company-review-response > strong { font-size: 12px; color: #478065; }\n  @media(max-width: 390px) { .company-map-cards { grid-template-columns: minmax(0, 1fr); } }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
